import { BellOutlined } from "@ant-design/icons";
import { Badge } from "antd";

import { useGetNotificationsUnreadCount } from "@/entities/notifications";
import { NavButton } from "@/modules/nav-button";
import { NotificationsPanel } from "@/modules/notifications/notifications-panel";

import "./nav-button-notifications.style.less";

export const NavButtonNotifications = () => {
  const { unreadCount } = useGetNotificationsUnreadCount();

  return (
    <NotificationsPanel>
      <Badge
        count={unreadCount}
        overflowCount={9}
        className="nav-button-notifications-badge"
      >
        <NavButton icon={<BellOutlined />} />
      </Badge>
    </NotificationsPanel>
  );
};
